import React, { useState, useEffect, useContext } from "react";
import { Textarea, TextareaWrapper, ErrorText } from "./styles";
import { Context } from "@components/useContext/context";
import { connect, useDispatch, useSelector } from "react-redux";
import { setPayloadData } from "@store/slices/globalState";
import { validateFunction } from "@utils/validate";
import { getErrorMessageForId, getWidgetSpecificProps } from "@utils/index";

const mapStateToProps = function (state: any, ownProps: any) {
  return {
    ...getWidgetSpecificProps(
      state.configuration?.normalisedConfig,
      ownProps.id
    ),
    errorMessage: getErrorMessageForId(
      state.configuration.normalisedConfig,
      ownProps.id
    )
  };
};

const TextareaField = (props: any) => {
  const dispatch = useDispatch();
  const { isDesktop } = useContext(Context);
  const {
    name,
    placeholder,
    defaultValue,
    payloadData = {},
    is_visible,
    inputStyles,
    wrapperStyles,
    ...rest
  } = props;

  const { globalPayload } = useSelector(({ globalState }: any) => ({
    globalPayload: globalState?.payloadData
  }));

  const getPrefilledData = () => {
    return "";
  };

  const [currentValue, setCurrentValue] = useState(getPrefilledData());
  const [touched, setTouched] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    dispatch(setPayloadData({ [name]: currentValue }));
  }, [currentValue]);

  const handleBlur = () => {
    setTouched(true);
    const err = validateFunction({ currentValue });
    setError(err);
  };

  if (is_visible === false) return null;

  return (
    <TextareaWrapper style={wrapperStyles}>
      <Textarea
        name={name}
        placeholder={placeholder}
        value={currentValue}
        onChange={(e) => setCurrentValue(e.target.value)}
        onBlur={handleBlur}
        isDesktop={isDesktop}
        style={inputStyles}
        {...rest}
      />
      {touched && error && <ErrorText>{error}</ErrorText>}
    </TextareaWrapper>
  );
};

export default connect(mapStateToProps)(TextareaField);